import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "combined",
    component: () =>
      import(/* webpackChunkName: "combined" */ "../views/CombinedMap.vue"),
  },
  {
    path: "/artaria",
    name: "artaria",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Artaria.vue"),
  },
  {
    path: "/cataris",
    name: "cataris",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Cataris.vue"),
  },
  {
    path: "/dairon",
    name: "dairon",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Dairon.vue"),
  },
  {
    path: "/burenia",
    name: "burenia",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Burenia.vue"),
  },
  {
    path: "/ferenia",
    name: "ferenia",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Ferenia.vue"),
  },
  {
    path: "/ghavoran",
    name: "ghavoran",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Ghavoran.vue"),
  },
  {
    path: "/elun",
    name: "elun",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Elun.vue"),
  },
  {
    path: "/hanubia",
    name: "hanubia",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Hanubia.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
